var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		_vm.$s.InputContainer,
		_vm.$s[("variant_" + _vm.variant)],
		( _obj = {}, _obj[_vm.$s.disabled] = _vm.disabled, _obj[_vm.$s.invalid] = _vm.invalid, _obj ) ],on:{"click":_vm.focus}},[_c('input',_vm._g(_vm._b({ref:"input",class:[
			_vm.$s.Input,
			_vm.$s[("align_" + _vm.align)] ],attrs:{"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('input:update', $event.target.value)}}},'input',_vm.$attrs,false),_vm.$listeners)),_vm._v(" "),(_vm.$slots.prefix)?_c('span',{class:[
			_vm.$s.Affix,
			_vm.$s.Prefix ]},[_vm._t("prefix")],2):_vm._e(),_vm._v(" "),(_vm.$slots.suffix)?_c('span',{class:[
			_vm.$s.Affix,
			_vm.$s.Suffix ]},[_vm._t("suffix")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }